import { Controller } from "@hotwired/stimulus"

// Handles template selection cards - shows loading state on the clicked card
// and disables all others to prevent duplicate submissions.
export default class extends Controller {
  static targets = ["button", "label", "description"]

  submit(event) {
    const form = event.target
    const clickedButton = form.querySelector("[data-template-select-target='button']")

    // Disable all buttons and dim non-selected cards
    this.buttonTargets.forEach((button) => {
      button.disabled = true
      if (button === clickedButton) {
        button.classList.add("border-indigo-500", "bg-indigo-50")
        button.classList.remove("hover:border-indigo-500", "hover:bg-indigo-50")
      } else {
        button.classList.add("opacity-40", "cursor-not-allowed")
      }
    })

    // Replace label with spinner on the clicked card
    const label = clickedButton.querySelector("[data-template-select-target='label']")
    const description = clickedButton.querySelector("[data-template-select-target='description']")

    if (label) {
      label.innerHTML = `<i class="fas fa-spinner fa-spin mr-2"></i> Generating\u2026`
    }
    if (description) {
      description.textContent = "This may take a moment"
    }
  }
}
